<template>
  <div :class="{ 'mars-ape-sider-collapse': isCollapse }" class="mars-ape-sider">
    <el-menu :collapse="isCollapse" :default-active="routePath" :unique-opened="true" active-text-color="#ff3176"
             background-color="#fff" text-color="#303133"
             class="sider-menu">
      <el-submenu :index="v['id'].toString()" :key="k" v-for="(v, k) in menuList">
        <template slot="title">
          <svg-icon style="margin-right: 10px;display: inline-block" :icon-class="v['icon']"></svg-icon>
          <span>{{ v['display_name'] }}</span>
        </template>
        <div class="sider-menu-sub">
          <el-menu-item :index="v['url']" :key="k" v-for="(v, k) in v['children']">
            <router-link :to="v['url']">
              <svg-icon style="margin-right: 10px;display: inline-block" :icon-class="v['icon']"></svg-icon>
              {{ v['display_name'] }}</router-link>
          </el-menu-item>
        </div>
      </el-submenu>
      <el-submenu index="all-menu-setting">
        <template slot="title">
          <i :class="[isCollapse ? 'is-collapse' : '']" class="el-icon-s-operation"></i>
          <span>全部菜单设置</span>
        </template>
        <el-menu-item index="/all_menu_setting">
          <router-link :to="`/all_menu_setting`"><i class="el-icon-s-grid"></i>全部菜单设置</router-link>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="icon-manage">
        <template slot="title">
          <i :class="[isCollapse ? 'is-collapse' : '']" class="el-icon-picture-outline"></i>
          <span>图标管理</span>
        </template>
        <el-menu-item index="/icon_manage">
          <router-link :to="`/icon_manage`"><i class="el-icon-picture-outline"></i>图标管理</router-link>
        </el-menu-item>
      </el-submenu>
      <el-submenu index="my">
        <template slot="title">
          <i :class="[isCollapse ? 'is-collapse' : '']" class="el-icon-user"></i>
          <span>个人中心</span>
        </template>
        <el-menu-item index="/user/profile">
          <router-link :to="`/user/profile`"><i class="el-icon-user-solid"></i>我的</router-link>
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import logo from '@/assets/logo.png'

export default {
  name: 'SiderMenu',
  data() {
    return {
      siteInfo: {
        logo: logo,
        name: '星象仪'
      },
    }
  },
  computed: {
    ...mapGetters(['isCollapse', 'menuList', 'routePath'])
  },
  methods: {
    ...mapMutations([
      // 'handleMenuList',
      'handleRoutePath'
      // 'handleUserPermissions',
      // 'handleUserDptInfo',
    ])
  },
  async created() {
    // let userMenuList = await this.$api.getUserMenuList()
    // let userPermissionsList = await this.$api.getUserPermissionsList()
    // await this.handleMenuList(userMenuList['list'])
    // await this.handleUserPermissions(userPermissionsList['list'])
    // await this.handleUserDptInfo(userPermissionsList['dpt_info'])
    if (Object.keys(this.$route.params).length !== 0 && this.$route.matched[1]) {
      this.handleRoutePath(this.$route.matched[1].path)
    } else {
      this.handleRoutePath(this.$route.path)
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
    .mars-ape-sider:not(.mars-ape-sider-collapse) {
        /* flex 0 0 256px */
        max-width: 160px !important;
        transition: all 0.3s;
    }

    .mars-ape-sider-collapse, .el-menu--collapse {
        /* flex 0 0 80px */
        width: 0 !important;
        transition: all 0.3s;
    }

    /* 导航头部 */

    .sider-logo {
        height: 64px;
        position: relative;
        line-height: 64px;
        padding-left: 24px;
        transition: all 0.3s;
        background-color: #fff;
        //background #000c17
        //background #002140
        overflow: hidden;

        img {
            display: inline-block;
            vertical-align: middle;
            width: 32px;
        }

        h1 {
            color: #000;
            display: inline-block;
            vertical-align: middle;
            font-size: 20px;
            margin: 0 0 0 12px;
            font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
            font-weight: 600;
        }
    }

    /* 导航内容 */
    .sider-menu {
        width: auto !important;
        transition: all 0.3s;
    }

    .el-menu {
        border-right: solid 0 !important;
        list-style: none;
        position: relative;
        margin: 0;
        padding-left: 0;
        background-color: #fff;
    }

    .sider-menu-sub {
        background: #fafafa;
        box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.06);
    }

    .el-submenu__title, .el-submenu__title {
        color: #303133;
    }

    .el-submenu__title {
        padding-left: 10px !important;
        padding-right: 10px !important;
        //margin-top 4px
        //margin-bottom 4px
        width: 100% !important;
        line-height: 40px;
        height: 40px;
    }

    .el-menu-item {
        height: 40px;
        line-height: 40px;
        padding-left: 48px !important;
        padding-right: 16px;
        margin-top: 4px;
        margin-bottom: 8px;
        color: #606266;

        a {
            color: #606266;
            text-decoration: none;
            display: block;
        }
    }

    .el-submenu [class^="iconfont"].is-collapse {
        padding-left: 8px;
        font-size: 16px;
    }

    .el-submenu > .el-submenu__title svg-icon, .el-submenu i:not(.is-collapse) {
        vertical-align: middle;
        margin-right: 10px;
        display: inline-block;
        min-width: 14px;
        text-align: center;
        font-size: 16px;
    }

    .el-menu-item:hover, .el-menu-item:focus {
        background-color: #fff0f3;
    }

    //.el-menu-item:hover a, .el-menu-item:focus a
    //  color #ffffff

    .el-submenu__title:hover, .el-submenu__title:focus {
        background-color: #fff0f3;
    }

    .el-submenu.is-active .el-submenu__title, .is-active > a, .el-submenu.is-active .el-submenu__title > i {
        color: #ff3176;
    }

    //.el-submenu__title:hover, .el-submenu__title:hover i, .el-submenu__title:focus i .el-submenu__title:focus
    //  background-color: #001529
    //  color #ffffff
    //
    //.el-submenu.is-opened .el-submenu__title, .el-submenu.is-opened .el-submenu__title > i, .el-submenu.is-active .el-submenu__title, .is-active > a, .el-submenu.is-active .el-submenu__title > i
    //  color #ffffff

    .el-menu-item.is-active {
        background-color: #fff0f3;
    }

    /* 折叠后子菜单效果 */
    .el-menu--vertical {
        left: 84px !important;
    }

    .el-menu--popup {
        border-radius: 4px;
        min-width: 160px;
    }
</style>
<style scoped>
    .logo-title {
        color: #000;
        font-size: 1.2rem;
        margin: 0 0 0 12px;
        font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
        font-weight: 600;
    }
    .sider-menu svg-icon, .sider-menu i {
       vertical-align: middle;
       margin-right: 5px;
       width: 24px;
       text-align: center;
       font-size: 16px;
       color: #606266;
     }
</style>
